import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Bono } from '../interfaces/interfaces';
import { UsuarioService } from './usuario.service';

const URL = environment.url;


@Injectable({
  providedIn: 'root'
})
export class BonoService {


  constructor( private http: HttpClient,
              private usuarioService: UsuarioService) { }

  public getBonos() {
    const headers = new HttpHeaders({
      'x-token': this.usuarioService.token
    });
    return this.http.get<Bono[]>(`${ URL }/bono`, {headers});
  }


  public addOrUpdateBono(bono: Bono) {
    const headers = new HttpHeaders({
      'x-token': this.usuarioService.token
    });
    if (bono._id && bono._id !== '') {
      if (bono.tipo !== '1') {
        bono.zonas = '';
      }
      return this.actualizarBono(bono, headers);
    } else {
      bono.sesiones_pendientes = bono.sesiones;
      return this.crearBono(bono, headers);
    }
  }

  private crearBono( bono: Bono, headers: HttpHeaders) {
    return new Promise<string>( resolve => {
      this.http.post(`${ URL }/bono/create`, bono, {headers})
        .subscribe( resp => {
          console.log("RESPUESTA", resp);
          if(resp['ok']) {
            const bonoN = resp['bonoBD'];
            resolve(bonoN._id);
          }
          resolve('');
        });
    });
  }

  private actualizarBono( bono: Bono, headers: HttpHeaders) {
    return new Promise<string>( resolve => {
      this.http.post(`${ URL }/bono/update`, bono, {headers})
        .subscribe( resp => {
          resolve(bono._id);
      });
    });
  }

  public actualizarBonoSimple( bono: Bono) {
    const headers = new HttpHeaders({
      'x-token': this.usuarioService.token
    });
    return new Promise<string>( resolve => {
      this.http.post(`${ URL }/bono/update`, bono, {headers})
        .subscribe( resp => {
          resolve(bono._id);
      });
    });
  }

  public getBonosByCliente(clienteId: string) {
    const headers = new HttpHeaders({
      'x-token': this.usuarioService.token
    });
    return this.http.get<Bono[]>(`${ URL }/bono/${ clienteId }`, {headers});
  }
  public eliminarBono(bonoId: string) {
    return new Promise( resolve => {
      const headers = new HttpHeaders({
      'x-token': this.usuarioService.token
      });
      return this.http.get<Bono>(`${ URL }/bono/delete/${ bonoId }`, {headers}).subscribe(resp =>{
        return resolve(true);
      }); 
    });
  }

  public getBonoById(bonoId: string) {
    const headers = new HttpHeaders({
      'x-token': this.usuarioService.token
    });
    return this.http.get<Bono>(`${ URL }/bono/bono/${ bonoId }`, {headers});
  }

  public getBonosActivosByClienteTipo(clienteId: string, tipo: string) {
    const headers = new HttpHeaders({
      'x-token': this.usuarioService.token
    });
    return this.http.get<Bono[]>(`${ URL }/bono/activo/${ clienteId }/${ tipo }`, {headers});
  }

  /*public getSesionesPendientesByBono(bono: Bono) {
      const headers = new HttpHeaders({
        'x-token': this.usuarioService.token
      });
      return this.http.get<Bono>(`${ URL }/cita/sesiones/${ bono._id }`, {headers});
  }*/
}
